<div class="title-container">
  <h2 class="title">
    {{ 'Reports.PortfolioReport.Title' | translate }}
  </h2>
  <hr class="separation-line" />
</div>

<div class="charts-container">
  <ng-container *ngIf="portfolioAnalysis$ | async as data">
    <div id="pdf-target">
      <div class="row-1">
        <app-quarters-success-rate [data]="data.quarterlyStatistics" [textColor]="textColor"
          [fontOptions]="fontOptions"></app-quarters-success-rate>
        <app-quarters-case-registration [data]="data.quarterlyStatistics" [textColor]="textColor"
          [fontOptions]="fontOptions"></app-quarters-case-registration>
        <app-quarters-totals [data]="data.quarterlyStatistics" [textColor]="textColor"
          [fontOptions]="fontOptions"></app-quarters-totals>
      </div>
      <div class="row-2">
        <app-debtors-ages-chart [data]="data.debtorAgeData" [textColor]="textColor"
          [fontOptions]="fontOptions"></app-debtors-ages-chart>
        <app-business-sectors [data]="data.businessSectorStatistics" [textColor]="textColor"
          [fontOptions]="fontOptions"></app-business-sectors>
      </div>
    </div>

    <div class="floating-panel">
      <button class="floating-round-button floating-info mr-2" (click)="downloadGraphsAsPDF()" matTooltip="{{ 'Reports.PortfolioReport.DownloadAsPDF' | translate }}" matTooltipPosition="above" matTooltipShowDelay="100">
        <i class="far fa-file-pdf"></i>
      </button>
    </div>    
  </ng-container>
</div>



